<template>
  <div class="lg:col-span-9">
    <div class="py-6 px-4 sm:p-6 lg:pb-8">

      <div v-if="regInProgress" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
        <p class="font-medium text-base mb-2">Осталась всего пара шагов!</p>
        <p>Введите данные о себе и нажмите &laquo;Продолжить&raquo;</p>
      </div>

      <ui-form @submit.prevent.stop="save" :errors="errors">
        <div>
          <div>
            <h2 class="text-lg leading-6 font-medium text-gray-900">Личная информация</h2>
            <p class="mt-1 text-sm text-gray-500">
              Используйте постоянный адрес, на который вы можете получать почту
            </p>
          </div>

          <div class="grid grid-cols-1 gap-x-4 sm:grid-cols-6">
            <ui-form-item class="mt-4 sm:col-span-3" label="Электронная почта" required
                          text-help="Email используется для входа в личный кабинет." name="email">
              <ui-form-text v-model="form.email"/>
            </ui-form-item>

            <ui-form-item class="mt-4 sm:col-span-3" label="Телефон" name="phone">
              <ui-form-tel v-model="form.phone"/>
            </ui-form-item>

            <ui-form-item class="mt-4 sm:col-span-3" label="Фамилия" required>
              <ui-form-text v-model="form.last_name"/>
            </ui-form-item>

            <ui-form-item class="mt-4 sm:col-span-3" label="Имя" required>
              <ui-form-text v-model="form.first_name"/>
            </ui-form-item>

            <ui-form-item class="mt-4 sm:col-span-4" label="Отчество">
              <ui-form-text v-model="form.patronymic"/>
            </ui-form-item>

          </div>

          <!--          <ui-form-item class="mt-4" label="Фото">
                      <div class="mt-1 ">
                        <div class="flex items-center">
                          <div class="flex-shrink-0 inline-block overflow-hidden" aria-hidden="true">
                            <ui-avatar-circular :name="form.name" :link="form.photo?.url"/>
                          </div>
                          <div class="ml-5 rounded-md shadow-sm">
                            <div
                                class="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-light-blue-500">
                              <label for="user_photo"
                                     class="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none">
                                <span>Выбрать...</span>
                                <span class="sr-only"> user photo</span>
                              </label>
                              <input id="user_photo" name="user_photo" type="file"
                                     class="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md">
                            </div>
                          </div>
                        </div>
                      </div>
                    </ui-form-item>-->
        </div>

        <div class="mt-6 py-4 text-right">
          <ui-button class="ml-6" type="submit">{{ regInProgress ? 'Продолжить' : 'Сохранить' }}</ui-button>
        </div>

      </ui-form>
    </div>
  </div>
</template>

<script>

import UiButton from "@/components/ui/button/UiButton";
import {mapGetters} from "vuex";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";
import UiFormTel from "@/components/ui/form/UiFormTel";
import UiForm from "@/components/ui/form/UiForm";
import UiAvatarCircular from "@/components/ui/elements/avatars/UiAvatarCircular";

export default {
  name: "UserProfile",
  // eslint-disable-next-line vue/no-unused-components
  components: {UiAvatarCircular, UiForm, UiFormTel, UiFormText, UiFormItem, UiButton},
  props: {
    user_id: {}
  },
  data() {
    return {
      errors: {},
      form: {
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        patronymic: '',
        photo: {
          url: ''
        }
      }
    }

  },
  methods: {
    async save() {
      const isreeg = this.regInProgress
      const fields = {
        email: this.form.email.trim(),
        phone: this.form.phone,
        first_name: this.form.first_name.trim(),
        last_name: this.form.last_name.trim(),
      }
      this.errors = {}
      try {
        await this.$store.dispatch('account/update', fields)
        if (isreeg) {
          this.$router.push({name: 'UserSchools', params: {user_id: this.user_id}})
        } else {
          this.$store.dispatch('alerts/success', {text: 'Данные пользователя обновлены.'})
        }
      } catch (e) {
        this.errors = e
      }

      /*      this.$api.user.saveProfile(this.user_id, this.form).then(user => {
              this.errors = {};
              if (parseInt(this.user_id) === parseInt(user.user_id)) {
                this.$store.dispatch('account/push', user);
              }
              this.loadForm(user)
              this.$store.dispatch('alerts/success', {text: 'Данные пользователя обновлены.'})
            }).catch(errors => {
              this.errors = errors;
            });*/

    },
    loadForm(user) {
      this.form = {...user};
    },
  },
  computed: {
    ...mapGetters('account', ['requiredName', 'id']),
    regInProgress() {
      return this.$store.getters['account/requiredName']
    }
  },
  async mounted() {
    this.regions = await this.$api.region.all()
    const user = await this.$api.user.profile(this.user_id);
    this.loadForm(user)
  }
}
</script>
